var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('div',{staticClass:"section-wrapper"},[_c('div',{staticClass:"section-title"},[_vm._v(" 一. "+_vm._s(_vm.entityJson.name)+" ")]),_c('Column2Chart',{staticClass:"column2Chart",attrs:{"chartData":_vm.entityJson.data}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }